export default "__VITE_ASSET__BXEswuHG__"